import React from 'react';

const Checked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd">
      <ellipse
        cx="12.11"
        cy="12"
        stroke="gray"
        strokeWidth="1.5"
        rx="11.36"
        ry="11.25"
      />
      <path
        fill="gray"
        d="M16.47 8l-5.928 6.54-3.293-3.107-1.194 1.243L10.639 17l7.119-7.854z"
      />
    </g>
  </svg>
);

export default Checked;
